<script lang="ts">
    import { commandInput } from "../lib/commandInput.svelte.ts";

    // Verbs shown for every object. template() receives the reference string
    // ("#objid" when available, else the display name).
    const VERBS: { label: string; template: (ref: string) => string }[] = [
        { label: "look at",  template: r => `look at ${r}` },
        { label: "examine",  template: r => `examine ${r}` },
        { label: "take",     template: r => `take ${r}` },
        { label: "drop",     template: r => `drop ${r}` },
        { label: "put … in", template: r => `put ${r} in ` },
        { label: "give",     template: r => `give ${r} to ` },
        { label: "read",     template: r => `read ${r}` },
        { label: "smell",    template: r => `smell ${r}` },
        { label: "listen to",template: r => `listen to ${r}` },
        { label: "touch",    template: r => `touch ${r}` },
    ];

    function select(verb: typeof VERBS[0]) {
        const m = commandInput.contextMenu;
        if (!m) return;
        const ref = m.objId ?? m.objName;
        commandInput.prefill(verb.template(ref));
    }

    function onKeydown(e: KeyboardEvent) {
        if (e.key === "Escape") commandInput.closeContextMenu();
    }

    // Clip the menu so it doesn't overflow the viewport.
    function menuStyle(x: number, y: number): string {
        const w = 180, h = VERBS.length * 30 + 36;
        const left = Math.min(x, window.innerWidth  - w - 8);
        const top  = Math.min(y, window.innerHeight - h - 8);
        return `left:${left}px;top:${top}px`;
    }
</script>

{#if commandInput.contextMenu}
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
        class="ctx-backdrop"
        onclick={() => commandInput.closeContextMenu()}
        oncontextmenu={(e) => { e.preventDefault(); commandInput.closeContextMenu(); }}
        onkeydown={onKeydown}
        role="presentation"
    ></div>

    <menu
        class="ctx-menu"
        style={menuStyle(commandInput.contextMenu.x, commandInput.contextMenu.y)}
        onkeydown={onKeydown}
    >
        <li class="ctx-header" title={commandInput.contextMenu.objId ?? ""}
        >{commandInput.contextMenu.objName}</li>
        <li class="ctx-rule" role="separator"></li>
        {#each VERBS as verb}
            <li>
                <button
                    class="ctx-item"
                    onclick={() => select(verb)}
                >{verb.label}</button>
            </li>
        {/each}
    </menu>
{/if}

<style>
    .ctx-backdrop {
        position: fixed;
        inset: 0;
        z-index: 900;
    }

    .ctx-menu {
        position: fixed;
        z-index: 901;
        min-width: 180px;
        background: rgba(8, 6, 4, 0.97);
        border: 1px solid rgba(180, 155, 100, 0.35);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.85);
        padding: 0;
        margin: 0;
        list-style: none;
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.78rem;
    }

    .ctx-header {
        padding: 0.45em 0.75em 0.3em;
        color: #8a7840;
        font-size: 0.7rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 220px;
        cursor: default;
        user-select: none;
    }

    .ctx-rule {
        height: 1px;
        background: rgba(180, 155, 100, 0.18);
        margin: 0 0.5em;
    }

    .ctx-item {
        display: block;
        width: 100%;
        padding: 0.32em 0.75em;
        background: transparent;
        border: none;
        color: #c5b890;
        text-align: left;
        font-family: inherit;
        font-size: inherit;
        cursor: pointer;
        transition: background 0.1s;
    }

    .ctx-item:hover {
        background: rgba(180, 155, 100, 0.12);
        color: #e0d0a0;
    }
</style>
